module.exports = __webpack_public_path__ + "img/boat5.135b8bbe.jpg";